import styled from '@emotion/styled';

import { Link } from '@/components/router/Link';

const ActionsContainer = styled.div`
  display: flex;
  gap: var(--whitespace-narrow-responsive, 16px);
`;

const Card = styled.div`
  --list-margin-bottom: 0;
  --list-margin-top: 0;

  background: var(--white);
  padding: var(--whitespace-narrower-responsive);

  h6 {
    margin-bottom: 0;
  }
`;

const DOBCheckForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const StyledLink = styled(Link)`
  align-items: center;
  display: inline-flex;
  margin: 24px 0;
  text-decoration: none;
`;

const OutletContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 12px;

  > *:first-of-type {
    flex-grow: 1;
    height: auto;
  }
`;

const SessionDetailsAside = styled.aside<{ align?: string }>`
  display: flex;
  align-items: ${(props) => props.align ?? 'start'};
`;

const SessionDetailsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: var(--whitespace-wide, 24px);
  justify-content: space-between;
  max-width: 632px;
`;

const SessionKeyCode = styled.span`
  background-color: var(--light-grey);
  font-size: 16px;
  padding: var(--whitespace-narrower, 8px) var(--whitespace-narrow, 12px);
`;

const SessionKeyCodeContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
`;

const Sessions = styled.div`
  flex-direction: column;
  display: flex;
  margin: var(--whitespace-medium-responsive, 24px) 0;
  gap: var(--whitespace-narrow-responsive, 16px);
`;

const TabsContainer = styled.ul`
  display: grid;
  grid-auto-flow: column;
  margin: 0;
  padding: 0;
`;

const TabElement = styled.li`
  display: contents;
`;

const TabLink = styled(Link)`
  align-items: center;
  border-bottom: 4px solid var(--tab-link-border-color);
  color: var(--tab-link-text-color);
  cursor: pointer;
  display: flex;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  height: 66px;
  justify-content: center;
  line-height: 100%;
  margin: 0;
  padding: 0;
  position: relative;
  text-align: center;
  text-decoration: none;

  &:visited {
    color: var(--tab-link-text-color);
  }

  &.active {
    font-weight: bold;
    color: var(--tab-link-text-color-active);
    border-bottom: 4px solid var(--tab-link-border-color-active);
  }
`;

export {
  ActionsContainer,
  Card,
  DOBCheckForm,
  StyledLink,
  OutletContainer,
  SessionDetailsAside,
  SessionDetailsContainer,
  SessionKeyCode,
  SessionKeyCodeContainer,
  Sessions,
  TabElement,
  TabLink,
  TabsContainer,
};
